import { render, staticRenderFns } from "./SubHeaderPodcasts.vue?vue&type=template&id=6ddffe6c&scoped=true"
import script from "./SubHeaderPodcasts.vue?vue&type=script&lang=js"
export * from "./SubHeaderPodcasts.vue?vue&type=script&lang=js"
import style0 from "./SubHeaderPodcasts.vue?vue&type=style&index=0&id=6ddffe6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddffe6c",
  null
  
)

export default component.exports